import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Tax } from '../../entities/tax.entity';

export const taxActions = createActionGroup({
  source: 'Tax',
  events: {
    'load tax data': emptyProps(),
  },
});

export const taxApiActions = createActionGroup({
  source: 'Tax API',
  events: {
    'load tax data success': props<{ tax: Tax[] }>(),
    'load tax data failure': props<{ error: HttpErrorResponse }>(),
  },
});
